import { render, staticRenderFns } from "./personcourse.vue?vue&type=template&id=4624aa9d"
import script from "./personcourse.vue?vue&type=script&lang=ts"
export * from "./personcourse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports